<template>
    <div v-if="$store.state.user.permissions.indexOf('tracker-template-manage') >= 0">
        <Header></Header>
        
        <div class="main-inner">
            <template>
                <TemplatesList></TemplatesList>
                <h4 class="heading4 mb-4">Customizations</h4>
                <div class="tabs-secondary">
                    <a @click="currentTab = 'submitter'" class="tabs-secondary__tab" :class="{active: currentTab == 'submitter'}">
                        Details Fields
                    </a>
                    <a @click="currentTab = 'reviewer'" class="tabs-secondary__tab" :class="{active: currentTab == 'reviewer'}">
                        Reviewer Fields
                    </a>
                    <a @click="currentTab = 'questions'" class="tabs-secondary__tab" :class="{active: currentTab == 'questions'}">
                        Startup Questions
                    </a>
                    <a @click="currentTab = 'diligence'" class="tabs-secondary__tab" :class="{active: currentTab == 'diligence'}">
                        Startup Diligence
                    </a>
                    <a @click="currentTab = 'pipelines'" class="tabs-secondary__tab" :class="{active: currentTab == 'pipelines'}">
                        Funnels
                    </a>
                </div>
        
                <div v-show="currentTab == 'submitter'">
                    <FieldsList
                        type="tracker_submit">
                    </FieldsList>
                </div>

                <div v-show="currentTab == 'reviewer'">
                    <FieldsList
                        type="tracker_review">
                    </FieldsList>
                </div>

                <div v-show="currentTab == 'questions'">
                    <FieldsList
                        type="tracker_question">
                    </FieldsList>
                </div>

                <div v-show="currentTab == 'diligence'">
                    <FieldsList
                        type="tracker_diligence">
                    </FieldsList>
                </div>

                <div v-show="currentTab == 'pipelines'">
                    <FieldsList
                        type="pipeline"
                        fieldType="pipeline"
                    >
                    </FieldsList>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Header from "@/components/settings/Header"
import FieldsList from "@/components/trackers/FieldsList"
import TemplatesList from "@/components/trackers/TemplatesList";

export default {
    components: {
        Header,
        FieldsList,
        TemplatesList,
    },

    data() {
        return {
            currentTab: "submitter",
        }
    },
}
</script>

<style scoped>

</style>